module.exports = __webpack_public_path__ + "img/docs-2.4cf6adef.png";